import { Box } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import * as React from 'react';
import { Filters, VdsTableProps } from './VdsTable';

/** Stili di default per le sezioni della tabella */
const pageNumberPaginationStyle = {
    fontSize: '14px',
    '.MuiPaginationItem-firstLast': {
        color: '#0090D1'
    },
    '.MuiPaginationItem-previousNext': {
        color: '#0090D1'
    },
    '.Mui-selected': {
        backgroundColor: 'white!important',
        color: '#0090D1'
    },
    'button:hover:not(Mui-selected)': {
        backgroundColor: '#DEF0F7',
        color: '#0090D1'
    }
};

const pageNumberPaginationContainerStyle = {
    marginTop: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
}

type VdsPageNumberPaginationProps<R> = {
    loader: boolean;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    options: VdsTableProps<R>['options'];
    submit: (filters: Partial<Filters>) => void;     // Evento di applicazione del filtro
}

export const VdsPageNumberPagination: <R>(props: VdsPageNumberPaginationProps<R>) => React.ReactElement = (props) => {

    return (
        <Box component="span" sx={pageNumberPaginationContainerStyle} >
            {props.loader && props.options?.usePagination && (
                <>-</>
            )}
            {!props.loader && props.options?.usePagination && (
                <Pagination
                    count={props.pageSize > 0 ? Math.ceil(props.totalCount / props.pageSize) : 0}
                    page={props.pageNumber}
                    shape="rounded"
                    siblingCount={0} 
                    onChange={(ev, pageNumber) => props.submit({ pageNumber })}
                    sx={pageNumberPaginationStyle}
                    showFirstButton
                    showLastButton
                />
            )}
        </Box>
    );
}